enum SUPPORTED_LOCALES {
  en = "English",
}

const DEFAULT_LOCALE: keyof typeof SUPPORTED_LOCALES = "en";

enum COMPONENT_VISIBILITY {
  visible = "visible",
  hidden = "hidden",
}

enum AUTH_METHOD {
  SIGN_UP_WITH_EMAIL = "SIGN_UP_WITH_EMAIL",
  SIGN_IN_WITH_EMAIL = "SIGN_IN_WITH_EMAIL",
}

export { SUPPORTED_LOCALES, DEFAULT_LOCALE, AUTH_METHOD, COMPONENT_VISIBILITY };
